module.exports = __webpack_public_path__ + "img/guiji.32993449.png";